import BttfAxios from '@features/utils/axios';
import axios, { AxiosResponse } from 'axios';
import { TPitchId } from '@company/components/FeedSelect/IFeedSelect';

class CompaniesPageServiceClass {

  private config = { headers: { 'Cache-Control': 'no-cache' } };
  private companyId: number;

  // What about using BttfAxios?
  public getFeed(companyId: number = this.companyId, path: string, pitchId?: TPitchId,
                 parentId?: number, perPage?: number, updateOnly: boolean = false): Promise<AxiosResponse<any>> {
    const params = BttfAxios.paramBuilder({
      pitch_id: pitchId, parent_id: parentId, per_page: perPage, company_update: String(updateOnly),
    });
    return axios.get(`/api/companies/${companyId}/conversations/${path}${params}`, this.config);
  }

  public getCollaborators(): Promise<AxiosResponse<any>> {
    const companyId = this.getCompanyId();
    return axios.get(`/api/companies/${companyId}/verification/collaborators`, this.config);
  }

  public postFeed(data: any, path: string): Promise<AxiosResponse<any>> {
    const companyId = this.getCompanyId();
    return axios.post(`/api/companies/${companyId}/conversations/${path}`, data);
  }

  public followPost(postId: number, follow: boolean = true, subscriptionId: number | null) {
    const companyId = this.getCompanyId();
    return follow ?
    axios.post(`/api/companies/${companyId}/conversations/${postId}/posts_subscribers`)
      :
    axios.delete(`/api/companies/${companyId}/conversations/${postId}/posts_subscribers/${subscriptionId}`);
  }

  public votePost(postId: number, vote:string = '', remove: boolean = false, update: boolean = false) {
    const companyId = this.getCompanyId();

    return update ?
      axios.patch(`/api/companies/${companyId}/conversations/${postId}/vote`, { vote: { type: vote } })
      : remove ?
      axios.delete(`/api/companies/${companyId}/conversations/${postId}/vote`)
      :
      axios.post(`/api/companies/${companyId}/conversations/${postId}/vote`, { vote: { type: vote } });
  }

  public reportPost(postId: number, data: object) {
    const companyId = this.getCompanyId();

    return axios.post(`/api/companies/${companyId}/conversations/${postId}/report`, { report: data });
  }

  public getCompanyId() {
    return this.companyId;
  }

  public setCompanyId(companyId: number) {
    this.companyId = companyId;
  }

  public getPost(postId: number, path: string):Promise<AxiosResponse> {
    const companyId = this.getCompanyId();
    return axios.get(`/api/companies/${companyId}/conversations/${path}/${postId}`);
  }
}

const CompaniesPageService = new CompaniesPageServiceClass();

export default CompaniesPageService;
